import {
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

@Component(
  {
    selector: 'app-chip',
    templateUrl: './chip.component.html',
    styleUrls: ['./chip.component.scss'],
    standalone: false
}
)
export class ChipComponent {
  @Input() info: string;
  @Output() removed: EventEmitter<string> = new EventEmitter<string>();
  @Input() regex: RegExp;

  remove() {
    this.removed.emit(this.info);
  }
}
